import {
  Box,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Tr,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import MainModel from "../../../../components/Models/main-model";
import { closeResetPasswordModel } from "../../../../modules/admin-modules/models/Actions";

const ResetPassword = () => {
  const openResetPassword = useSelector((state) => state.model.isOpen40);
  const resetPasswordData = useSelector((state) => state.superadminstudents.resetPasswordData);
  const dispatch = useDispatch();
  
  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        كلمة المرور الجديدة
      </Heading>
    </Box>
  );

  const closeFunc = () => {
    dispatch(closeResetPasswordModel());
  };
  
  return (
    <MainModel header={header} closeFunc={closeFunc} openVar={openResetPassword}>
      <TableContainer>
        <Table variant="striped" dir="rtl">
          <Tbody>
            <Tr>
              <Td>اسم الطالب</Td>
              <Td>{resetPasswordData?.name}</Td>
            </Tr>
            <Tr>
              <Td>كلمة المرور الجديدة</Td>
              <Td>{resetPasswordData?.unhashed_password}</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </MainModel>
  );
};

export default ResetPassword;

